import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import React from 'react'

import styles from '../Preview/preview.module.scss'

const DictionaryTable = ({ dict }: { dict: any }) => {
  const keys = Object.keys(dict)
  return (
    <TableContainer className={styles.tableContainer}>
      <Table size="small" aria-label="details">
        <TableBody>
          {keys.map(key => (
            <TableRow key={key}>
              <TableCell component="th" scope="row">
                {key}
              </TableCell>
              <TableCell>{dict[key]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DictionaryTable
